import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/house/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/house/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/house/locales/fi/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages);


export class IconHouse24 extends LitElement {
  render() {
      const title = i18n.t({ message: `House`, id: 'icon.title.house', comment: 'Title for house icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="24"height="24"fill="none"viewBox="0 0 24 24" part="w-icon-house-24-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 9.5V21a2 2 0 0 0 2 2h4v-4.815c0-1.595 1.343-2.889 3-2.889s3 1.294 3 2.89V23h4a2 2 0 0 0 2-2V9.5"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m1.5 10.5 9.158-8.286a2 2 0 0 1 2.684 0L22.5 10.5"></path></svg>`; }
}
if (!customElements.get('w-icon-house-24')) {
  customElements.define('w-icon-house-24', IconHouse24);
}